import Page from 'flarum/common/components/Page';
import DiscussionPage from 'flarum/common/components/DiscussionPage';
import DiscussionHero from 'flarum/common/components/DiscussionHero';
import app from 'flarum/common/app';
import ItemList from 'flarum/common/utils/ItemList';
import Link from 'flarum/components/Link';
import LoadingIndicator from 'flarum/components/LoadingIndicator';
import DiscussionGalleryImages from './galleryimages';
import { Fancybox } from '@fancyapps/ui';


var aArray = new Array();


export default class GalleryPage extends DiscussionPage {

    view() {
      if (this.loading) {
        return <LoadingIndicator />;
      }


      //read discussion title and set html title
      if (typeof this.discussion !== undefined && this.discussion !== null) {

        const discussion = this.discussion;
        let title = discussion.title() + ' képgaléria';

        app.setTitle(title);
        app.setTitleCount(0);

        return (
          <div className="DiscussionGallery">
            <div className="DiscussionPage-discussion">
              <DiscussionHero discussion={this.discussion} />
              <div className="container">
                <nav className="DiscussionPage-nav">
                  <Link href={app.route.discussion(discussion)} className="gallery-link">Vissza a témára</Link>
                </nav>
                <div className="DiscussionPage-stream">
                  <DiscussionGalleryImages discussion={this.discussion} />
                </div>
              </div>
            </div>
          </div>
        );

      }

    }


}


